<template>
  <el-table
    :data="data"
    stripe
    style="width: 100%"
    size="medium"
    header-row-class-name="common-table-header"
    row-class-name="common-table-row"
    class="is-print-hide common-table"
    :border="false"
  >
    <el-table-column prop="userName" label="药师名称" />
    <el-table-column prop="type" label="打卡类型" width="150">
      <template #default="{ row }">
        <span :class="{ highlight: row.type === 3 || row.type === 4 }">{{ transformPunchType(row.type) }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="punchTime" label="打卡时间" width="320">
      <template #default="{row}">
        <span :class="{ highlight: row.type === 3 || row.type === 4 }">{{ row.punchTime }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="punchChannel" label="打卡方式" width="152">
      <template #default="{row}">
        <span :class="{ highlight: row.type === 3 || row.type === 4 }">{{ row.punchChannel }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'punchTable',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    transformPunchType(type) {
      switch (type) {
        case 1:
          return '上班';
        case 2:
          return '下班';
        case 3:
          return '下班缺卡';
        case 4:
          return '上班缺卡';
        default:
          return '未识别';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-table {
  /deep/.common-table-header {
    .cell {
      line-height: 40px;
    }
  }

  .highlight {
    color: #eb5c57;
  }
}
</style>
